import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton/RaisedButton';
import { Box } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
// import Paper from 'material-ui/Paper';
import Formsy from 'formsy-react';
import { FormsyDate } from 'formsy-material-ui/lib';
import Spinner from '../../../components/common/Spinner/Spinner';
import { addDaysToDate } from '../../../utils/datetimeconverter';
import TeamsAvailabilityTable from '../TeamAvailability/TeamsAvailabilityTable';
import DefaultTable from '../TeamAvailability/DefaultTable';
import { TeamsAvailabilityStructurePropType } from '../../../propTypes/entities/teamsAvailabilityStructure';
import { getDateForApi } from '../../../utils/dates';
import { teamsEndpoint } from '../../../settings/constants';
import ApiSelector from '../../../containers/common/selectors/selectorContainer';
import { refSetter } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';
import { textFieldStyle, datePickerStyle, common } from '../../../theme/AllocateBaseTheme';

const locale = globals.getArea('dashboard');

class TeamAvailabilityForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      teamsAvailability: [],
      OrgUnitsIds: [],
    };
  }

  setRef = refSetter.bind(this);

  handleChange = data => {
    this.setState({
      OrgUnitsIds: data.OrgUnitsIds,
      date: data.SelectedDate,
    });
  };

  handleSubmit = data => {
    this.setState({
      OrgUnitsIds: data.OrgUnitsIds,
      date: data.SelectedDate,
    });
    this.props.getTeamAvailability({ OrgUnitsIds: data.OrgUnitsIds, SelectedDate: getDateForApi(data.SelectedDate) });
  };

  handleArrowClick = days => () => {
    const newDate = addDaysToDate(this.state.date, days);
    this.setState({
      date: new Date(newDate),
    });
    this.props.getTeamAvailability({ OrgUnitsIds: this.state.OrgUnitsIds, SelectedDate: getDateForApi(newDate) });
  };

  render() {
    const { teamsAvailability } = this.props;
    let teamsAvailabilityTable = null;
    if (teamsAvailability.length > 0) {
      teamsAvailabilityTable = <TeamsAvailabilityTable {...teamsAvailability} />;
    } else {
      teamsAvailabilityTable = <DefaultTable {...this.state} />;
    }
    return (
      <div className="full-page">
        <div className="filter-section">
          {/* <Typography className="ellipsis" variant="h4">
            {locale.getMsg('teamAvailabilityHeader')}
          </Typography> */}
          <Formsy.Form ref={this.setRef('form')} onSubmit={this.handleSubmit} onChange={this.handleChange}>
            <div style={{ width: '100%' }}>
              <Box display="flex" px={1}>
                <Box p={1} width="100%" flexGrow={1}>
                  <ApiSelector
                    reduxIdentifier="teams"
                    endpoint={teamsEndpoint}
                    multiple
                    required
                    floatingLabelText={`${locale.getMsg('teamChooseDropdownControlHint')}*`}
                    name="OrgUnitsIds"
                    isFetchRequired
                  />
                </Box>
                <Box p={1} width="100%" flexGrow={1}>
                  <FormsyDate
                    required
                    name="SelectedDate"
                    value={this.state.date}
                    className="date-picker"
                    floatingLabelText="Choose a date"
                    floatingLabelStyle={common.floatingLabelStyle}
                    floatingLabelShrinkStyle={common.floatingLabelShrinkStyle}
                    floatingLabelFocusStyle={common.floatingLabelFocusStyle}
                    underlineStyle={common.underlineStyle}
                    textFieldStyle={datePickerStyle.textFieldStyle}
                    inputStyle={textFieldStyle.inputStyle}
                  />
                </Box>
                <Box p={1} flexShrink={0}>
                  <RaisedButton
                    type="submit"
                    label={locale.getMsg('submitButton')}
                    primary
                    style={{ display: 'flex', height: 45 }}
                  />
                </Box>
              </Box>
            </div>
          </Formsy.Form>
        </div>
        <Box display="flex" justifyContent="flex-end" p={1}>
          <Box p={0}>
            <IconButton onClick={this.handleArrowClick(7)} aria-label="delete" color="primary">
              <ArrowBackIcon />
            </IconButton>
          </Box>
          <Box p={0}>
            <IconButton onClick={this.handleArrowClick(-7)} color="primary" aria-label="Arrow Forward">
              <ArrowForwardIcon />
            </IconButton>
          </Box>
        </Box>
        <div style={{ padding: '0 16px' }}>
          <div style={{ marginBottom: 0, flexDirection: 'row-reverse' }} />
          <div>{this.props.isFetching ? <Spinner /> : teamsAvailabilityTable}</div>
        </div>
      </div>
    );
  }
}

TeamAvailabilityForm.defaultProps = {
  teamsAvailability: [],
};

TeamAvailabilityForm.propTypes = {
  getTeamAvailability: PropTypes.func.isRequired,
  teamsAvailability: PropTypes.arrayOf(PropTypes.shape(TeamsAvailabilityStructurePropType)),
  isFetching: PropTypes.bool.isRequired,
};

export default TeamAvailabilityForm;
